"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RequiredOption_1 = require("../RequiredOption");
const CreativeFormatAspectRatio_1 = require("./CreativeFormatAspectRatio");
class SupportingCreativeFormatAspectRatioItem {
    constructor({ aspectRatio, presetSize, requiredOption, }) {
        this.toJSON = () => ({
            aspectRatio: this.aspectRatio.toJSON(),
            presetSize: this.presetSize.toJSON(),
            requiredOption: this.requiredOption,
        });
        this.aspectRatio = aspectRatio;
        this.presetSize = presetSize;
        this.requiredOption = requiredOption;
    }
}
SupportingCreativeFormatAspectRatioItem.fromJSON = (json) => {
    const { aspectRatio, presetSize, requiredOption } = Object.assign({}, json);
    const _requiredOption = requiredOption ? RequiredOption_1.default.fromJSON(requiredOption) : undefined;
    return new SupportingCreativeFormatAspectRatioItem({
        aspectRatio: CreativeFormatAspectRatio_1.AspectRatio.fromJSON(aspectRatio),
        presetSize: CreativeFormatAspectRatio_1.DisplaySize.fromJSON(presetSize),
        requiredOption: _requiredOption,
    });
};
exports.default = SupportingCreativeFormatAspectRatioItem;
